export enum PROPOSAL_STATUSES {
  ACTIVATED = 'ACTIVATED',
  DELETED = 'DELETED',
  PENDING = 'PENDING',
}

export enum PROPOSALS_REFERENCE_CATEGORIES {
  ACTIVITY = 'Activities',
  UNIVERSITY = 'Universities',
}

export enum PROPOSAL_ACTIVITY_FIELD {
  NAME = 'Name',
}

export enum PROPOSAL_UNIVERSITY_FIELD {
  NAME = 'Name',
}

export enum PROPOSAL_CONFIGURE_TYPE {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}
